module.exports = __webpack_public_path__ + "static/media/symptoms-vitals-and-lifestyle-tracking-01@2x.9f919da8.png";